<template>
  <div>
    <img alt="Signature" v-show="showImage" :src="signatureUrl" />
    <canvas v-show="showContext" id="canvas" ref="canvas"
            @mousedown="start('start-drawing', $event)"
            @pointerdown="start('start-drawing', $event)"
            @gotpointercapture="start('start-drawing', $event)"
            @mousemove="draw('draw-it', $event)"
            @pointermove="draw('draw-it', $event)"
            @pointerrawupdate="draw('draw-it', $event)"
            @mouseup="stop('stop-it', $event)"
            @pointerup="stop('stop-it', $event)"
            @pointerlostupdate="stop('stop-it', $event)"
            @mouseout="stop('stop-it', $event)"
    ></canvas>

    <v-btn v-if="showImage" fab color="primary" @click="clear">
      <v-icon>mdi-delete-forever</v-icon>
    </v-btn>
  </div>
</template>
<style>
#canvas {
  border: black dashed thick
}
</style>

<script>
import { photoService, webSocketService } from "@/services/question";
import Vue from "vue";

export default {
  name: "Signature",
  props: {
    questionId: String,
    signatureUrl: String,
    bus: Vue
  },
  data() {
    return {
      is_drawing: false,
      showContext: false,
      showImage: false,
      context: null
    };
  },
  methods: {
    saveSignature() {
      if (this.showContext && this.$refs.canvas) {
        this.$refs.canvas.toBlob((blob) => {
          const formData = new FormData();
          formData.append("file", blob);
          photoService.savePhoto(formData).then(req => {
            webSocketService.send({ "questionId": this.questionId, "signature": req.data.photoPath });
          });
        }, "image/jpeg");
      } else {
        webSocketService.send({ "questionId": this.questionId, "signature": this.signatureUrl });
      }
    },
    start(message, event) {
      this.is_drawing = true;
      this.context.beginPath();
      this.context.moveTo(
        event.clientX - this.$refs.canvas.getBoundingClientRect().left,
        event.clientY - this.$refs.canvas.getBoundingClientRect().top
      );
      event.preventDefault();
    },
    draw(message, event) {
      if (this.is_drawing) {
        this.context.lineTo(
          event.clientX - this.$refs.canvas.getBoundingClientRect().left,
          event.clientY - this.$refs.canvas.getBoundingClientRect().top
        );
        this.context.strokeStyle = "blue";
        this.context.lineWidth = "2";
        this.context.lineCap = "round";
        this.context.lineJoin = "round";
        this.context.stroke();
      }
      event.preventDefault();
    },
    stop(message, event) {
      if (this.is_drawing) {
        this.context.stroke();
        this.context.closePath();
        this.is_drawing = false;
      }
      event.preventDefault();
    },
    clear() {
      if (this.showImage) {
        this.showImage = false;
        this.showContext = true;
      }
      this.context.fillStyle = "white";
      this.context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      this.context.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
    }
  },
  mounted() {
    // create background
    this.$refs.canvas.width = 300;
    this.$refs.canvas.height = 200;
    this.context = this.$refs.canvas.getContext("2d");

    if (this.signatureUrl) {
      this.showImage = true;
    } else {
      this.showContext = true;
      this.context.fillStyle = "white";
      this.context.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
    }
  },
  created() {
    this.bus.$on("saveSignature", () => {
      this.saveSignature();
    });
  }
};
</script>
